import i18n from '@/lib/i18n';
import _ from 'lodash';

export const constructEnum = (name, enums) => {
  const inverted = _.invert(enums);
  const t = v => i18n.t(`${name}.${inverted[v]}`);
  const te = v => i18n.te(`${name}.${inverted[v]}`);
  const key = v => inverted[v];
  const values = _.values(enums);
  return {
    ...enums,
    t,
    te,
    key,
    options(values = enums) {
      return _.map(values, value => ({ value, label: t(value) }));
    },
    values,
    toKey: v => inverted[v],
    hasValue: v => values.includes(v)
  };
};
